import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { toast } from 'react-toastify';

const FileUploader = ({ handleFileRemove, files, setFiles }) => {

    const onDrop = useCallback(
        (acceptedFiles) => {
            setFiles((prevFiles) => {
                const existingFiles = prevFiles.map((f) => f.name + f.size);
                const newFiles = acceptedFiles.filter(
                    (file) => !existingFiles.includes(file.name + file.size)
                );

                if (prevFiles.length + newFiles.length > 10) {
                    toast.error("Maximum 10 files are allowed");
                    return prevFiles;
                }

                if (newFiles.length < acceptedFiles.length) {
                    toast.warning("Some duplicate files were ignored.");
                }

                return [...prevFiles, ...newFiles];
            });
        },
        [setFiles]
    );


    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: true, // Allow multiple files to be uploaded
    });

    return (
        <div>
            <div
                {...getRootProps({ className: 'dropzone' })}
                style={{
                    border: '2px dashed #e55426',
                    padding: '80px',
                    width: '100%',
                    textAlign: 'center',
                    borderRadius: '8px',
                    cursor: 'pointer',
                }}
            >
                <input {...getInputProps()} />
                <p>Drag & drop some files here, or click to select files</p>
            </div>

            <div>
                {/* <ul>
                    {files.map((file, index) => (
                        <li key={index}>{file.name}</li>
                    ))}
                </ul> */}
                <ul className="private-public-folder">
                    {files.map((file, index) => (
                        <li key={file + index}>
                            {file.name} {" "}
                            <button title="Remove File
                                      " type="button" onClick={() => handleFileRemove(file)} style={{
                                    all: 'unset',
                                    cursor: 'pointer',
                                }}><RemoveCircleOutlineOutlinedIcon sx={{ color: "#e55426" }} /></button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default FileUploader;
